import {
  useCallback, useEffect, useLayoutEffect, useRef,
} from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { usePopstate } from 'utils/hooks/usePopstate';
import { usePrevious } from 'utils/hooks/usePrevious';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';

const RESTORATION_PATHS = [
  ROUTE_PATH[ROUTE_NAME.RESULTS],
  ROUTE_PATH[ROUTE_NAME.SEARCH],
];

export const ScrollManager = () => {
  const { pathname } = useLocation();
  const previousPathname = usePrevious(pathname);
  const scrollPositionByPathRef = useRef({});

  useEffect(() => {
    const scrollListener = () => {
      scrollPositionByPathRef.current[window.location.pathname] = document.body.scrollTop;
    };
    window.addEventListener(
      'scroll',
      scrollListener,
      true,
    );
    return () => {
      window.removeEventListener(
        'scroll',
        scrollListener,
        true,
      );
    };
  }, []);

  usePopstate(useCallback(() => {
    const isRestorationPath = RESTORATION_PATHS.some((path) => matchPath(window.location.pathname, {
      path,
      exact: true,
    }));

    const position = scrollPositionByPathRef.current[window.location.pathname];

    if (isRestorationPath && position) {
      document.body.scrollTop = position;
    }
  }, []));

  useLayoutEffect(() => {
    if (pathname === previousPathname) {
      return;
    }

    // happens before popstate event listener is called
    document.body.scrollTop = 0;
  }, [pathname, previousPathname]);

  return null;
};
